exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-toolbar > .md-toolbar[data-v-6ad54f95] {\n  background: #fafafa;\n}\n.main-toolbar > .md-toolbar header[data-v-6ad54f95] {\n    display: table;\n}\n.main-toolbar > .md-toolbar header > div[data-v-6ad54f95] {\n      display: table-cell;\n      vertical-align: middle;\n}\n.main-toolbar > .md-toolbar h1[data-v-6ad54f95] {\n    font-weight: normal;\n    font-size: 1.2rem;\n    margin-bottom: 0;\n}\n.maintenance-information[data-v-6ad54f95] {\n  padding-top: 0.5rem;\n}\n.maintenance-information .maintenance-type[data-v-6ad54f95] {\n    padding-left: 1rem;\n    text-align: left;\n    margin-bottom: 0;\n}\n.maintenance-information .recall-date[data-v-6ad54f95] {\n    padding-right: 1rem;\n    text-align: right;\n    margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ad54f95","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/globals/MainHeader.vue
// module id = 87tE
// module chunks = 1